// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2nFhu","alertIcon":"ConfirmModal_alertIcon__1tjK4"};